import { MapContainer, Marker, TileLayer, useMapEvents } from "react-leaflet";
import L from "leaflet";
// Importing OSM_TILE_URL/OSM_ATTRIBUTION from this tiny module rather than
// from GeoreferencedMap.tsx directly avoids pulling react-leaflet/leaflet
// into the main bundle a second time through GeoreferenceDialog.tsx's static
// import chain, which used to defeat GeoreferencedMap's own lazy() wrapping.
import { OSM_ATTRIBUTION, OSM_TILE_URL } from "./osmTileSource.ts";

interface PickerRow {
  id: string;
  label: string;
  color: string;
  target: { lat: number; lng: number } | null;
}

function numberedMarkerIcon(label: string, color: string): L.DivIcon {
  return L.divIcon({
    className: "control-point-marker-icon",
    html: `<div style="background:${color};width:24px;height:24px;border-radius:50%;display:flex;align-items:center;justify-content:center;color:white;font:600 12px system-ui,sans-serif;border:2px solid white;box-shadow:0 1px 3px rgba(0,0,0,0.4)">${label}</div>`,
    iconSize: [24, 24],
    iconAnchor: [12, 12],
  });
}

function ClickToPick({ onPick }: { onPick: (lat: number, lng: number) => void }) {
  useMapEvents({ click: (e) => onPick(e.latlng.lat, e.latlng.lng) });
  return null;
}

// Clicking anywhere sets/moves the currently active row's marker; other rows
// with a point already placed stay visible, numbered.
export function ControlPointPickerMap({
  rows,
  onPick,
}: {
  rows: PickerRow[];
  onPick: (lat: number, lng: number) => void;
}) {
  return (
    <MapContainer center={[20, 0]} zoom={2} scrollWheelZoom className="control-point-picker-map">
      <TileLayer url={OSM_TILE_URL} attribution={OSM_ATTRIBUTION} maxNativeZoom={19} maxZoom={22} />
      <ClickToPick onPick={onPick} />
      {rows
        .filter(
          (row): row is PickerRow & { target: { lat: number; lng: number } } => row.target !== null
        )
        .map((row) => (
          <Marker
            key={row.id}
            position={[row.target.lat, row.target.lng]}
            icon={numberedMarkerIcon(row.label, row.color)}
          />
        ))}
    </MapContainer>
  );
}
